export const CONVERSION_RATE_CATEGORIES = {
  LEAD_GENERATION: {
    id: "lead_generation",
    label: "Lead Generation",
    description: "Convert leads to exclusive listings",
    color: "#6366f1",
    icon: "Users",
  },
  BUYER_JOURNEY: {
    id: "buyer_journey",
    label: "Buyer Journey",
    description: "Track buyer from lead to close",
    color: "#10b981",
    icon: "ShoppingCart",
  },
  SELLER_JOURNEY: {
    id: "seller_journey",
    label: "Seller Journey",
    description: "Track seller from lead to close",
    color: "#f59e0b",
    icon: "Home",
  },
  CLOSING: {
    id: "closing",
    label: "Closing",
    description: "Final stage conversions",
    color: "#8b5cf6",
    icon: "CheckCircle",
  },
};

export const CONVERSION_RATE_CONFIG = [
  // Lead Generation
  {
    key: "lead_to_bov",
    label: "Lead to BOV",
    description: "Leads → Broker Opinion of Value",
    numeratorLabel: "BOVs",
    denominatorLabel: "Leads",
    category: "lead_generation",
    order: 1,
  },
  {
    key: "bov_to_exclusive",
    label: "BOV to Exclusive",
    description: "BOVs → Exclusive Listings",
    numeratorLabel: "Exclusives",
    denominatorLabel: "BOVs",
    category: "lead_generation",
    order: 2,
  },
  // Buyer Journey
  {
    key: "buyer_lead_to_buyer_initial_offer",
    label: "Lead to Offer",
    description: "Buyer Leads → Initial Offers",
    numeratorLabel: "Initial Offers",
    denominatorLabel: "Buyer Leads",
    category: "buyer_journey",
    order: 1,
  },
  {
    key: "buyer_initial_offer_to_executed_loi",
    label: "Offer to LOI",
    description: "Initial Offers → Executed LOIs",
    numeratorLabel: "Executed LOIs",
    denominatorLabel: "Buyer Initial Offers",
    category: "buyer_journey",
    order: 2,
  },
  {
    key: "buyer_executed_loi_to_uc",
    label: "LOI to Under Contract",
    description: "Executed LOIs → Under Contract",
    numeratorLabel: "Under Contracts",
    denominatorLabel: "Buyer Executed LOIs",
    category: "buyer_journey",
    order: 3,
  },
  {
    key: "buyer_uc_to_closed",
    label: "Under Contract to Closed",
    description: "Under Contract → Closed Deals",
    numeratorLabel: "Closed Deals",
    denominatorLabel: "Buyer Under Contracts",
    category: "buyer_journey",
    order: 4,
  },
  // Seller Journey
  {
    key: "seller_lead_to_seller_initial_offer",
    label: "Lead to Offer",
    description: "Seller Leads → Initial Offers",
    numeratorLabel: "Initial Offers",
    denominatorLabel: "Seller Leads",
    category: "seller_journey",
    order: 1,
  },
  {
    key: "exclusives_to_initial_offer",
    label: "Exclusive to Offer",
    description: "Exclusives → Initial Offers",
    numeratorLabel: "Initial Offers",
    denominatorLabel: "Exclusives",
    category: "seller_journey",
    order: 2,
  },
  {
    key: "seller_initial_offer_to_executed_loi",
    label: "Offer to LOI",
    description: "Initial Offers → Executed LOIs",
    numeratorLabel: "Executed LOIs",
    denominatorLabel: "Seller Initial Offers",
    category: "seller_journey",
    order: 3,
  },
  {
    key: "seller_executed_loi_to_uc",
    label: "LOI to Under Contract",
    description: "Executed LOIs → Under Contract",
    numeratorLabel: "Under Contracts",
    denominatorLabel: "Seller Executed LOIs",
    category: "seller_journey",
    order: 4,
  },
  {
    key: "seller_uc_to_closed",
    label: "Under Contract to Closed",
    description: "Under Contract → Closed Deals",
    numeratorLabel: "Closed Deals",
    denominatorLabel: "Seller Under Contracts",
    category: "seller_journey",
    order: 5,
  },
  // Combined/Closing
  {
    key: "initial_offer_to_executed_loi",
    label: "Offer to LOI (All)",
    description: "All Initial Offers → Executed LOIs",
    numeratorLabel: "Executed LOIs",
    denominatorLabel: "Initial Offers",
    category: "closing",
    order: 1,
  },
  {
    key: "executed_loi_to_uc",
    label: "LOI to Under Contract (All)",
    description: "All Executed LOIs → Under Contract",
    numeratorLabel: "Under Contracts",
    denominatorLabel: "Executed LOIs",
    category: "closing",
    order: 2,
  },
  {
    key: "uc_to_closed",
    label: "Under Contract to Closed (All)",
    description: "All Under Contracts → Closed Deals",
    numeratorLabel: "Closed Deals",
    denominatorLabel: "Under Contracts",
    category: "closing",
    order: 3,
  },
];

export const getConfigByKey = (key) => {
  return CONVERSION_RATE_CONFIG.find((config) => config.key === key);
};

export const getConfigsByCategory = (categoryId) => {
  return CONVERSION_RATE_CONFIG.filter((config) => config.category === categoryId)
    .sort((a, b) => a.order - b.order);
};

export const getCategoryById = (categoryId) => {
  return CONVERSION_RATE_CATEGORIES[categoryId.toUpperCase()];
};
